import React, { useState } from 'react'

import PropTypes from 'prop-types'

import BolaNmeroAtiva from './bola-nmero-ativa'
import BolaNmeroInativa from './bola-nmero-inativa'
import './bola-nmero.css'

const BolaNmero = (props) => {
  const [isAtivo, setIsAtivo] = useState(false)
  return (
    <div className={`bola-nmero-bola-1 ${props.rootClassName} `}>
      {isAtivo && (
        <div className="bola-nmero-ativa">
          <BolaNmeroAtiva
            numero={props.numero}
            rootClassName="bola-nmero-ativa-root-class-name"
          ></BolaNmeroAtiva>
        </div>
      )}
      {!isAtivo && (
        <div className="bola-nmero-inativa">
          <BolaNmeroInativa
            numero={props.numero}
            rootClassName="bola-nmero-inativa-root-class-name"
          ></BolaNmeroInativa>
        </div>
      )}
    </div>
  )
}

BolaNmero.defaultProps = {
  numero: '1',
  rootClassName: '',
}

BolaNmero.propTypes = {
  numero: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default BolaNmero
